import React, { useMemo } from "react";
import { useContract } from "../ContractContext";
import ErrorMessage from "../../shared/error/ErrorMessage";
import { useHistory } from "react-router-dom";
import ActivatedContractTypePage, {
  ActivatedContractBenefitList,
} from "./ActivatedContractTypePage";
import { CustomerViewModel } from "../../shared/models/CustomerViewModel";
import PageNavigationFooter, {
  FooterLink,
  PageFooterCell,
} from "@teamscheme/page-navigation-footer";
import { useMembershipContractClient } from "./MembershipContractClient";
import { TitleSection } from "../../formatting/CardSection";
import { LocationDescriptor } from "history";
import { STANDARD_BENEFITS } from "./StandardCard";
import { ContractType } from "../model/ContractViewModel";
import { PREMIUM_BENEFITS } from "./PremiumCard";

export function MemberContractBenefitsList() {
  return (
    <ActivatedContractBenefitList
      benefits={[...STANDARD_BENEFITS, ...PREMIUM_BENEFITS].filter(
        (x) => !x.excludeMembers
      )}
    />
  );
}

export default function MemberContractPage({
  prevUrl,
  nextUrl,
  customer,
}: {
  prevUrl?: LocationDescriptor;
  nextUrl: LocationDescriptor;
  customer: CustomerViewModel | null;
}) {
  const contract = useContract();

  const title = useMemo(() => {
    if (contract.contractType?.current === ContractType.Member) {
      return contract.contractType.upgradedCustomerId
        ? `Kontrakten er oppgradert med medlemsnummer ${contract.contractType.upgradedCustomerId}`
        : "Kontrakten er oppgradert";
    }

    return "Oppgrader med medlemskap";
  }, [contract.contractType]);

  const history = useHistory();
  const client = useMembershipContractClient();

  async function activate(
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) {
    event.preventDefault();
    await client.activate();
    if (nextUrl) history.push(nextUrl);
  }

  const onClickNext = !client.isActive ? activate : undefined;
  return (
    <ActivatedContractTypePage>
      <TitleSection title={title}>
        {contract.contractType?.current !== ContractType.Member && customer ? (
          <p>Du er logget inn med medlemsnummer {customer.customerId}.</p>
        ) : null}
        <p>Nå har du tilgang til:</p>
        <MemberContractBenefitsList />
        {client.error ? (
          <ErrorMessage>En feil har opptsått! Prøv igjen.</ErrorMessage>
        ) : null}
      </TitleSection>
      <PageNavigationFooter>
        {prevUrl ? (
          <FooterLink direction="back" linkTo={prevUrl} />
        ) : (
          <PageFooterCell />
        )}
        <FooterLink
          direction="next"
          linkTo={nextUrl}
          disabled={client.isLoading}
          onClick={onClickNext}
        />
      </PageNavigationFooter>
    </ActivatedContractTypePage>
  );
}
